<template>
  <div class="flex">
    <sidebar :routes="sidebarRoutes" />
    <main-container>
      <router-view />
      <pagination-buttons :pages="pages"></pagination-buttons>
    </main-container>
  </div>
</template>

<script>
const Sidebar = () =>
  import(/* webpackChunkName: "SidebarComponent" */ "@/components/Global/Sidebar");
const MainContainer = () =>
  import(/* webpackChunkName: "MainContainerComponent" */ "@/components/Global/MainContainer.vue");
const PaginationButtons = () =>
  import(/* webpackChunkName: "PaginationButtons" */ "@/components/Global/PaginationButtons.vue");

export default {
  name: "MyInterests",
  components: {
    Sidebar,
    MainContainer,
    PaginationButtons
  },
  computed: {
    /*
     * @computed - pages
     * Array of pages href names that will be passed to pagination buttons component
     */
    pages() {
      return this.sidebarRoutes.map(route => route.href);
    },
    /*
     * @computed - sidebarRoutes
     * Data required for each route on the sidebar component
     */
    sidebarRoutes() {
      return [
        {
          description: this.$t("myInterests.abstract.pageLabel"),
          icon: ["fas", "id-card-alt"],
          href: "MyInterestsAbstract"
        },
        {
          description: this.$t("myInterests.engineering.pageLabel"),
          icon: ["fas", "code"],
          href: "Engineering"
        },
        {
          description: this.$t("myInterests.business.pageLabel"),
          icon: ["fas", "briefcase"],
          href: "Business"
        },
        {
          description: this.$t("myInterests.sports.pageLabel"),
          icon: ["fas", "running"],
          href: "Sports"
        },
        {
          description: this.$t("myInterests.arts.pageLabel"),
          icon: ["fas", "palette"],
          href: "Arts"
        }
      ];
    }
  }
};
</script>
